// eslint-disable-next-line import/no-extraneous-dependencies
import { styled } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { QTypography, QButton, QModal, QModalContent, QModalActions, QModalTitle } from '@kw/quokka-ui';

export const KwConfirmationModal = ({ title, isOpen, onClose, description, onConfirm, extraDetails }: IProps) => {
  return (
    <QModal
      open={isOpen}
      title={
        <QModalTitle onClose={onClose} closeIcon={<CloseIcon />}>
          <QTypography variant="h3Medium" id="confirmation-modal-title">
            {title}
          </QTypography>
        </QModalTitle>
      }
      aria-labelledby="confirmation-modal-title"
      aria-describedby="confirmation-modal-description"
      onClose={onClose}
      content={
        <QModalContent sx={{ padding: '16px 29px 29px 16px' }}>
          <div id="confirmation-modal-description">
            <QTypography variant="bodyRegular">Are you sure you want to {description}?</QTypography>
          </div>

          {extraDetails && (
            <div id="confirmation-modal-extra-details" style={{ marginTop: '16px' }}>
              {extraDetails}
            </div>
          )}
        </QModalContent>
      }
      actions={
        <QModalActions>
          <StyledButtonsContainer>
            <QButton onClick={onClose}>Cancel</QButton>
            <QButton
              variant="filled"
              onClick={() => {
                onConfirm();
                onClose();
              }}
            >
              Confirm
            </QButton>
          </StyledButtonsContainer>
        </QModalActions>
      }
    ></QModal>
  );
};
interface IProps {
  title: string;
  isOpen: boolean;
  onClose: () => void;
  description: string;
  onConfirm: () => void;
  extraDetails?: React.ReactNode;
}

const StyledButtonsContainer = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
});
